module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("AB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ACCS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ancient Christian Commentary on Scripture")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ACNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Augsburg Commentaries on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ACW")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ancient Christian Writers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(", 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1887; reprint, Grand Rapids: Eerdmans, 1951–1956; reprint, Peabody, MA: Hendrickson, 1994.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("BCOTWP")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Baker Commentary on the Old Testament Wisdom and Psalms")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("BECNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("CBQMS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Catholic Biblical Quarterly Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("CC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Continental Commentaries")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("CEB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Common English Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("CO")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Corpus Reformatorum: Ioannis Calvini Opera quae supersunt omnia")]), _vm._v(", ed. W. Baum et al. Brunswick: C.A. Schwetschke & Filium, 1863–1900.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("DBW")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Dietrich Bonhoeffer Werke")]), _vm._v(", 17 vols. Edited by Eberhard Bethge et al. Munich: Chr. Kaiser/Güttersloher Verlagshaus, 1986–99.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("DBWE")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Dietrich Bonhoeffer Works")]), _vm._v(", English edition, 17 vols. Edited by Victoria J. Barnett, Wayne Whitson Floyd Jr., and Barbara Wojhoski. Minneapolis: Fortress, 1996–2015.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ESV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("IBC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JPS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Jewish Publication Society")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JSNTSup")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JSPSup")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Journal for the Study of the Pseudepigrapha Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Library of Christian Classics")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("LNTS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Library of New Testament Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NCB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New Century Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NICNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NICOT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Commentary on the Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NIV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("NPNF ")]), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("A Select Library of Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(", 1st series, 14 vols. Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894; reprint, Grand Rapids: Eerdmans, 1952–1956; reprint, Peabody, MA: Hendrickson, 1994.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("OSHT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Oxford Studies in Historical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("OTL")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Old Testament Library")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("PG")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Patrologia graeca [= "), _c('i', [_vm._v("Patrologiae Cursus Completus")]), _vm._v(": Series Graeca]. Edited by Jacques-Paul Migne. 162 vols. Paris, 1857–1886.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("PTMS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Pittsburgh Theological Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("RSV")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBL")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Society of Biblical Literature")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studies in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SFEG")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Schriften der Finnischen Exegetischen Gesellschaft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Siphrut")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Siphrut: Literature and Theology of the Hebrew Scriptures")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SP")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Sacra Pagina")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SVTP")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studia in Veteris Testamenti Pseudepigraphica")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("WBC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("WUNT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 72
// module chunks = 0